import React, { useMemo, useState } from 'react';

import './TopviewSubmenu.scss';
import { mikaSceneList, sceneList } from './scene.helper';
import PreviewSceneImage from './PreviewSceneImage';

export default function TopviewSubmenu({
  scenes,
  currentPano,
  onSelect,
  sceneDetail,
  isDropdown = false,
  onItemClick,
}) {
  // const isMobile = useMemo(() => window.innerWidth < 768, []);
  const [hover, setHover] = useState(null);
  const subTopviewScenes = useMemo(
    () =>
      scenes
        .filter((scene) =>
          sceneDetail.id === 'jasari-scene'
            ? scene.id !== 'jasari-scene' && sceneList.includes(scene.id)
            : scene.id !== 'jasari-scene' && mikaSceneList.includes(scene.id)
        )
        .sort((a, b) => {
          const aTitle = typeof a === 'object' ? a.title : a;
          const bTitle = typeof b === 'object' ? b.title : b;
          return aTitle.localeCompare(bTitle);
        }),
    [sceneDetail.id, scenes]
  );

  return (
    <div
      className={`topview-scenes ${isDropdown ? 'dropdown-menu' : ''}`}
      onClick={(e) => e.stopPropagation()}
    >
      {subTopviewScenes.length &&
        subTopviewScenes.map((scene, index) => (
          <div
            className="topview-item"
            key={index}
            onMouseEnter={() => setHover(index)}
            onMouseLeave={() => setHover(null)}
            onClick={() => {
              onSelect(scene.groupId, scene.id);
              // Close dropdown after selection if in dropdown mode
              if (isDropdown && onItemClick) {
                onItemClick();
              }
              // setOpenMobileMenu && setOpenMobileMenu();
            }}
          >
            <p
              className={`topview-title ${
                currentPano?.id === scene.id ? 'current-scene' : ''
              }`}
            >
              <span style={{ marginRight: '2px' }}>+</span>
              <span>{scene.title}</span>
            </p>

            <div className="topview-preview-container">
              <PreviewSceneImage
                subTopviewScenes={subTopviewScenes}
                indexHover={hover}
              />
            </div>
          </div>
        ))}
    </div>
  );
}
